(ns web3.modals.screens
  (:require [re-frame-simple.db :as db]
            [re-frame.core :as rf]
            [reagent.ratom :refer-macros [reaction]]
            [web3.modals.core :as modal]
            [web3.components.widgets :as widgets]
            [web3.i18n :as i]
            [web3.view :as v]
            [web3.log :as log]
            [web3.routing.core :as routing]))

(defn close!
  [router]
  (rf/dispatch [:routing/nav (routing/path-for router nil)]))

(v/defview lightbox-slider
  "Container for screens which implements slide-in transitions, based on the current screen's position in a sequence"
  [{:keys [on-close-lightbox
           route-params
           handler
           view
           z-index]
    :as route}]
  (let [{:keys [query
                id
                ids
                next-href
                wide?
                class]} (v/class-get view :modal-props)
        {:keys [entity model searchModels]
         :as query} (query route-params)
        searchModels (->> searchModels
                          first)]
    [modal/lightbox
     {:key "details"
      :z-index z-index
      :id (id route-params)
      :ids (ids route-params)
      :wide? (wide? route-params)
      :link-fn (fn [id]
                 (next-href route-params id))
      :class class
      :on-close on-close-lightbox}
     [:div.relative
      (modal/header
       (merge
         {:modal/closable? (some? on-close-lightbox)
          :key "header"
          :title (i/get handler route-params)
          :after ^{:key "query-state"} [widgets/graphql-state query]}
        (let [header (v/class-get view :header)]
          (if (fn? header)
            (header route-params)
            header))))
      (cond
        (some? entity) [view entity]
        (some? searchModels) [view searchModels]
        (some? model) [view model])]]))

(v/defview router-frames
  "Wraps the current match for `router` with `modal-view`"
  [{:keys [router modal-view z-index hidden? modal/closable?]
    :or {closable? true}}]
  (when-let [{:as router-data
              :keys [view]} (db/get-in [:db/routers router])]
    (when-not hidden?
      [modal-view (assoc router-data
                    :z-index z-index
                    :on-close-lightbox (when closable?
                                         (partial close! router))
                    :on-close (or (v/class-get view :modal/on-close)
                                  #(do (routing/nav! (routing/path-for router nil))
                                       true)))])))

(comment
  :test
  (last (routing/breadcrumbs :router/content-modal))
  (db/get-in [:db/routers :router/content-modal]))
